import { AppContext } from "App";
import Page from "components/base/Page";
import { useContext } from "react";
import { Link } from "react-router-dom";
import DevLogs from "./DevLogs";

const ITMainPage = () => {
  const { hasPermission } = useContext(AppContext);

  const hasAccess = hasPermission();

  return (
    <Page
      title="Recent Update"
      leftButtons={
        hasAccess && (
          <div className="flex space-x-2">
            <Link to="/it/components">组件展示</Link>
            <Link to="/it/test-odoo">测试Odoo</Link>
          </div>
        )
      }
    >
      <DevLogs />
    </Page>
  );
};

export default ITMainPage;
